import {
  Checkbox,
  Dropdown,
  Form,
  Icon,
  Input,
  Select,
} from 'semantic-ui-react';
import { useStore } from '../../../../app/stores/store';
import { SyntheticEvent, useEffect, useRef, useState } from 'react';
import { IFormDetails } from '../../../../app/stores/dashboardConfiguration/types';
import { datagridMasterElementType } from './type';
import {
  criteriaOptions,
  masterSelectionOptions,
  staticOptions,
} from './dropdownOptions';
import {
  static_items,
  static_items_id,
  static_workLevel,
  static_worklevel_id,
} from '../constants';
import agent from '../../../../app/api/agent';

function DataGrid() {
  const {
    DashboardConfigurationStore,
    metaDataStore: {
      loadMetaDataAT,
      assetTypesDropdownList,
      loadMetaDataATById,
      elementTypeDropdownList,
    },
  } = useStore();
  const [selectedMetaData, setSelectedMetaData] = useState<
    { elementName: string; elementType: string }[]
  >([]);
  const [metaDataList, setMetaDataList] = useState<
    { key: string; text: string; value: string }[]
  >([]);
  const [showCriteria, setShowCriteria] = useState<
    { elementId: string; criteria: { type: string; value: string }[] }[]
  >([]);
  const [masterGroupSelection, setMasterGroupSelection] = useState<string>('');
  const [assetTypesList, setAssetTypesList] = useState<
    { key: string; text: string; value: string }[]
  >([]);
  const [elementTypesList, setElementTypesList] = useState<
    { key: string; text: string; value: string }[]
  >([]);
  const [itemMetaDataOptions, setItemMetaDataOptions] = useState<
    { key: string; text: string; value: string }[]
  >([]);
  const [basedOnOptions, setBasedOnOptions] = useState<
    { key: string; text: string; value: string }[]
  >([]);

  const { dataGrid, GETMasterMetaData } = DashboardConfigurationStore;
  const dependencyMaster = useRef<string>('');
  const [editAndDeleteValue, SetEditAndDeleteValue] = useState<{
    metadata: string;
    comparison: string;
    value: string;
  }>({
    metadata: '',
    comparison: '',
    value: '',
  });

  const selectStyle = {
    display: 'inline-block',
    marginRight: '10px', // Adjust the margin as needed
    width: '25%',
  };

  const getParsedMasterElement = () => {
    return JSON.parse(dataGrid?.masterElement);
  };

  useEffect(() => {
    if (dataGrid?.masterElement && selectedMetaData.length > 0) {
      getParsedMasterElement().forEach((items: datagridMasterElementType) => {
        Object.entries(items).forEach(([key, item]) => {
          if (key === 'editAndDelete') {
            if (typeof item === 'object') {
              if (
                'metadata' in item &&
                'comparison' in item &&
                'value' in item
              ) {
                const editAndDeleteItem = item as {
                  metadata: string;
                  comparison: string;
                  value: string;
                };
                SetEditAndDeleteValue({
                  ...editAndDeleteValue,
                  metadata: editAndDeleteItem.metadata,
                  comparison: editAndDeleteItem.comparison,
                  value: editAndDeleteItem.value,
                });
              } else {
                // Handle other shapes of the 'item' object
              }
            }
          }
        });
      });
    }
    // eslint-disable-next-line
  }, [dataGrid?.masterElement, selectedMetaData]);

  useEffect(() => {
    if (selectedMetaData.length === 0) {
      SetEditAndDeleteValue({
        ...editAndDeleteValue,
        metadata: '',
        comparison: '',
        value: '',
      });
    }
    // eslint-disable-next-line
  }, [selectedMetaData]);
  const saveMasterElement = (
    tempMasterElement: datagridMasterElementType[],
  ) => {
    DashboardConfigurationStore.dataGrid = {
      ...DashboardConfigurationStore.dataGrid,
      masterElement: JSON.stringify(tempMasterElement),
    };
  };

  useEffect(() => {
    let tempMasterElement =
      dataGrid?.masterElement !== undefined ? getParsedMasterElement() : [];
    let tempMetaDataValue: { elementName: string; elementType: string }[] = [];
    let tempMetaDataList: { key: string; text: string; value: string }[] = [];
    let collectMetadataIDs: string[] = [];

    if (dataGrid?.masterId === static_items_id) {
      collectMetadataIDs = tempMasterElement
        ?.filter((t: any) => t.mode !== 2)
        .map((d: any) => d.elementName);
      itemMetaDataOptions?.forEach((tempData: any) => {
        if (collectMetadataIDs?.includes(tempData.value)) {
          tempMetaDataValue?.push({
            elementName: tempData.value,
            elementType: '',
          });
        }
      });
      saveMasterElement(tempMasterElement);
    } else if (dataGrid?.masterId !== static_worklevel_id) {
      dataGrid.metaData?.forEach((data: IFormDetails) => {
        tempMasterElement?.forEach(
          (selectedData: datagridMasterElementType) => {
            if (
              selectedData?.elementId === data.elementId &&
              selectedData?.mode !== 2 &&
              selectedData?.mode !== undefined
            ) {
              tempMetaDataValue?.push({
                elementName: data.elementName,
                elementType: data.elementType,
              });
            }
          },
        );
        tempMetaDataList?.push({
          key: data.elementId,
          text: data.elementName,
          value: data.elementName,
        });
        collectMetadataIDs?.push(data.elementId);
      });
      setMetaDataList(tempMetaDataList);

      const updateMasterElement: any[] = [];
      tempMasterElement?.forEach((data: any) => {
        if (collectMetadataIDs?.includes(data.elementId)) {
          updateMasterElement?.push(data);
        }
      });

      DashboardConfigurationStore.dataGrid = {
        ...DashboardConfigurationStore.dataGrid,
        masterElement: JSON.stringify(updateMasterElement),
      };
    }
    setSelectedMetaData(tempMetaDataValue);
    // eslint-disable-next-line
  }, [dataGrid?.metaData, itemMetaDataOptions]);

  useEffect(() => {
    let tempShowCriteria: {
      elementId: string;
      criteria: { type: string; value: string }[];
    }[] = [];
    let tempMasterElement =
      dataGrid?.masterElement !== undefined ? getParsedMasterElement() : [];
    tempMasterElement?.forEach((data: any) => {
      if (data?.criteria) {
        tempShowCriteria?.push({
          elementId: data.elementId,
          criteria: data?.criteria,
        });
      }
    });
    setShowCriteria(tempShowCriteria);
    // eslint-disable-next-line
  }, [dataGrid?.masterElement]);

  // useEffect(() => {
  //   // DashboardConfigurationStore.dataGrid = {
  //   //   ...DashboardConfigurationStore.dataGrid,
  //   //   masterId: '',
  //   //   masterName: '',
  //   // };
  //   // eslint-disable-next-line
  // }, [DashboardConfigurationStore.dataGrid.isMaster]);

  const setDataGridMetaData = (_event: any, data: any) => {
    let tempMasterElement: datagridMasterElementType[] = [];
    let tempMetadata: { elementName: string; elementType: string }[] = [];
    const dataValuesSet = new Set(data.value);
    const tempMasterElementMap: any = {};

    const processTempData = (tempData: any) => {
      const { elementId, elementName, elementType, elementValue } = tempData;

      const tempMasterElementGroup = getParsedMasterElement();
      if (!tempMasterElementGroup.length) {
        tempMasterElement?.push({
          elementId,
          elementName,
          elementType,
          elementValue,
          mode: 1,
        });
      }

      if (!dataValuesSet.has(elementName)) {
        tempMasterElementMap[elementId] = {
          elementId,
          elementName,
          elementType,
          elementValue,
          mode: 2,
        };
      } else {
        // If the element is in data.value, find the corresponding mode from tempMasterElementGroup
        const group = tempMasterElementGroup.find(
          (item: any) => item.elementName === elementName,
        );
        if (group) {
          tempMasterElementMap[elementId] = {
            elementId,
            elementName,
            elementType,
            elementValue,
            mode: group.mode === 0 ? 0 : 1,
            dependency: group.dependency,
            criteria: group.criteria,
          };
        } else {
          tempMasterElementMap[elementId] = {
            elementId,
            elementName,
            elementType,
            elementValue,
            mode: 1,
          };
        }
      }
    };

    if (dataGrid?.masterName === static_items) {
      itemMetaDataOptions?.forEach((tempData: any) => {
        if (data.value?.includes(tempData.value)) {
          tempMetadata?.push({
            elementName: tempData.value,
            elementType: tempData.value,
          });
          tempMasterElement.push({
            elementId: '',
            elementName: tempData.value,
            elementValue: '',
            mode: 1,
            criteria: undefined,
            dependency: undefined,
            elementType: '',
          });
        }
      });
      saveMasterElement(tempMasterElement);
    } else {
      dataGrid.metaData?.forEach((tempData: IFormDetails) => {
        if (data.value?.includes(tempData.elementName)) {
          tempMetadata?.push({
            elementName: tempData.elementName,
            elementType: tempData.elementType,
          });
        }
        processTempData(tempData);
      });
      const uniqueData = Object.values(tempMasterElementMap);
      saveMasterElement(uniqueData as datagridMasterElementType[]);
    }
    setSelectedMetaData(tempMetadata);
  };

  const changeComparision = (
    _event: any,
    data: any,
    id: string,
    index: number,
  ) => {
    let tempMasterElement = JSON.parse(dataGrid.masterElement);
    tempMasterElement?.forEach((tempData: datagridMasterElementType) => {
      if (tempData.elementId === id) {
        if (tempData.criteria) {
          tempData.criteria[index] = {
            type: data.value || '',
            value: '',
          };
        }
      }
    });
    saveMasterElement(tempMasterElement);
  };

  const addValue = (
    _event: any,
    data: any,
    id: string,
    type: string = 'equals',
    index: any,
  ) => {
    let tempMasterElement = JSON.parse(dataGrid.masterElement);
    tempMasterElement?.forEach((tempData: IFormDetails) => {
      if (tempData.elementId === id) {
        if (tempData.criteria) {
          tempData.criteria[index] = {
            type,
            value: data.value,
          };
        }
      }
    });
    saveMasterElement(tempMasterElement);
  };

  const switchMode = (data: IFormDetails) => {
    let tempMasterElement = JSON.parse(dataGrid.masterElement);
    tempMasterElement?.forEach((tempData: IFormDetails) => {
      if (tempData.elementId === data.elementId) {
        tempData.mode = data.mode === 1 ? 0 : 1;
      }
    });
    saveMasterElement(tempMasterElement);
  };

  const getAssetId = (assetName: string) => {
    let assetId = '';
    assetTypesList?.forEach((asset) => {
      if (asset.value === assetName) {
        assetId = asset.key;
        return;
      }
    });
    return assetId;
  };

  useEffect(() => {
    (async () => {
      if (dataGrid?.assetType !== undefined && dataGrid?.assetType !== '') {
        const assetId = getAssetId(dataGrid?.assetType);
        await loadMetaDataATById(assetId);
      }
    })();
    // eslint-disable-next-line
  }, [assetTypesList, dataGrid?.assetType]);

  useEffect(() => {
    setElementTypesList(elementTypeDropdownList);
    // eslint-disable-next-line
  }, [elementTypeDropdownList]);

  const handleAssetTypeChange = async (_e: any, data: any) => {
    if (data.value !== '') {
      const assetId = getAssetId(data.value);
      await loadMetaDataATById(assetId);
      setElementTypesList(elementTypeDropdownList);
    } else {
      setElementTypesList([]);
      DashboardConfigurationStore.dataGrid = {
        ...DashboardConfigurationStore.dataGrid,
        elementType: '',
      };
    }
    DashboardConfigurationStore.dataGrid = {
      ...DashboardConfigurationStore.dataGrid,
      assetType: data.value,
    };
  };

  useEffect(() => {
    loadMetaDataAT();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setAssetTypesList(assetTypesDropdownList);
    // eslint-disable-next-line
  }, [assetTypesDropdownList]);

  const handleMasterChange = async (_e: any, data: any) => {
    let tempMetaDataList: IFormDetails[] = [];
    let masterKey: string = '';
    if (data.value === static_items) {
      DashboardConfigurationStore.dataGrid = {
        ...DashboardConfigurationStore.dataGrid,
        masterName: data.value,
        masterId: static_items_id,
      };
    } else if (data.value === static_workLevel) {
      DashboardConfigurationStore.dataGrid = {
        ...DashboardConfigurationStore.dataGrid,
        masterName: data.value,
        masterId: static_worklevel_id,
        masterElement: '[]',
      };
    } else {
      dataGrid.data?.forEach(async (master) => {
        if (master.value === data.value) {
          masterKey = master.key;
          return;
        }
      });
      if (masterKey !== '') {
        tempMetaDataList = await GETMasterMetaData(masterKey);
      }
      DashboardConfigurationStore.dataGrid = {
        ...DashboardConfigurationStore.dataGrid,
        masterName: data.value,
        metaData: tempMetaDataList?.filter(
          (met) => met.isActive && !met.isDeleted,
        ),
        masterElement: masterKey === '' ? '[]' : dataGrid.masterElement,
      };
    }
  };

  const handleCriteria = (id: any) => {
    let tempMasterElement = JSON.parse(dataGrid.masterElement);
    tempMasterElement?.forEach((tempData: IFormDetails) => {
      if (tempData.elementId === id) {
        if (tempData.criteria) {
          tempData.criteria?.push({
            type: '',
            value: '',
          });
        } else {
          tempData.criteria = [
            {
              type: '',
              value: '',
            },
          ];
        }
      }
    });
    saveMasterElement(tempMasterElement);
  };

  const removeCriteria = (id: string, index: any) => {
    let tempMasterElement = JSON.parse(dataGrid.masterElement);
    tempMasterElement?.forEach((tempData: IFormDetails) => {
      if (tempData.elementId === id) {
        tempData = {
          ...tempData,
          criteria: tempData.criteria?.splice(index, 1),
        };
      }
    });
    saveMasterElement(tempMasterElement);
  };

  const setBasedOn = (_event: any, data: any, id: string) => {
    let tempMasterElement = getParsedMasterElement();
    tempMasterElement?.forEach((tempData: datagridMasterElementType) => {
      if (tempData.elementId === id) {
        tempData.dependency = {
          basedOn: data.value,
          checkWithOptions: tempData.dependency?.checkWithOptions || [],
          checkWith: tempData.dependency?.checkWith || '',
        };
      }
    });
    saveMasterElement(tempMasterElement);
  };

  const handleDependency = async (id: any, name: string, value: string) => {
    let result = await agent.dynamicMaster.getMasterDetailsAPI();
    let masterKey = '';
    const masterName = value?.split('|')?.[0];
    dependencyMaster.current = name;
    if (result?.data) {
      result?.data?.forEach((masters: any) => {
        if (masters.title === masterName) {
          masterKey = masters.masterId;
          return;
        }
      });
    }
    let tempMetaDataList: IFormDetails[] = [];
    if (masterKey !== '') {
      tempMetaDataList = await GETMasterMetaData(masterKey);
    }
    let tempCheckWithOptions: any = tempMetaDataList?.map((data) => {
      return {
        key: data.elementId,
        value: data.elementName,
        text: data.elementName,
      };
    });

    let tempMasterElement = getParsedMasterElement();
    tempMasterElement?.forEach((tempData: datagridMasterElementType) => {
      if (tempData.elementId === id) {
        tempData.dependency = {
          basedOn: '',
          checkWithOptions: tempCheckWithOptions,
          checkWith: '',
        };
      }
    });
    saveMasterElement(tempMasterElement);
  };

  const setCheckWith = (_event: any, data: any, id: string) => {
    let tempMasterElement = getParsedMasterElement();
    tempMasterElement?.forEach((tempData: IFormDetails) => {
      if (tempData.elementId === id) {
        if (tempData.dependency) {
          tempData.dependency = {
            basedOn: tempData.dependency.basedOn,
            checkWithOptions: tempData.dependency.checkWithOptions,
            checkWith: data.value,
          };
        }
      }
    });
    saveMasterElement(tempMasterElement);
  };

  const removeDependency = (id: string) => {
    let tempMasterElement = getParsedMasterElement();
    tempMasterElement?.forEach((tempData: IFormDetails) => {
      if (tempData.elementId === id) {
        delete tempData.dependency;
      }
    });
    saveMasterElement(tempMasterElement);
  };

  useEffect(() => {
    const tempBasedOnOptions: { key: string; text: string; value: string }[] =
      [];
    selectedMetaData?.forEach(
      (opt: { elementName: string; elementType: string }) => {
        if (
          dependencyMaster.current !== opt.elementName &&
          opt.elementType === 'Masters'
        ) {
          tempBasedOnOptions?.push({
            key: opt.elementName,
            text: opt.elementName,
            value: opt.elementName,
          });
        }
      },
    );
    setBasedOnOptions(tempBasedOnOptions);
    // eslint-disable-next-line
  }, [selectedMetaData, dependencyMaster.current]);

  useEffect(() => {
    (async () => {
      // let itemMetaData = await axios.get<string[]>(
      //   `/MetadataKeys/Report_Key/Customer_Name/Key?customer=${userStore.user
      //     ?.customerName!}`,
      // );
      let itemMetaData = await agent.assetList.getItemsMetaData();
      // eslint-disable-next-line
      let temp: any = itemMetaData.data?.map((data: string) => {
        if (data !== 'Id') {
          return {
            key: data,
            value: data,
            text: data,
          };
        }
      });
      temp = temp.filter((data: any) => data !== undefined);
      setItemMetaDataOptions(temp);
    })();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (
      dataGrid?.masterName === static_items ||
      dataGrid?.masterName === static_workLevel
    ) {
      setMasterGroupSelection('static');
    } else if (dataGrid?.masterName !== '') {
      setMasterGroupSelection('dynamic');
    }
    // eslint-disable-next-line
  }, [dataGrid?.masterName]);

  const EditAndDeleteOptions = () => {
    return selectedMetaData.map((element) => ({
      key: element.elementName,
      text: element.elementName,
      value: element.elementName,
    }));
  };

  const handleEditAndDeleteComparison = (type: string, value: string) => {
    let tempMasterElement = JSON.parse(dataGrid.masterElement);

    const editAndDeleteObject = {
      metadata: editAndDeleteValue.metadata || '',
      comparison: type || editAndDeleteValue.comparison || '',
      value: value || editAndDeleteValue.value || '', // If needed
    };
    let updatedTempMasterElement = tempMasterElement.map(
      (tempData: datagridMasterElementType) => {
        if (tempData.elementName === editAndDeleteValue.metadata) {
          // Update the element with the new editAndDelete object
          return {
            ...tempData,
            editAndDelete: editAndDeleteObject,
          };
        } else {
          return tempData; // Return the original element unchanged
        }
      },
    );
    saveMasterElement(updatedTempMasterElement);
  };
  const clearEditAndDelete = () => {
    SetEditAndDeleteValue({
      ...editAndDeleteValue,
      metadata: '',
      comparison: '',
      value: '',
    });
    const tempMasterElement = getParsedMasterElement().map(
      (item: datagridMasterElementType) => {
        // Create a new object without the "editAndDelete" property
        const { editAndDelete, ...newItem } = item;
        return newItem;
      },
    );
    saveMasterElement(tempMasterElement);
  };
  return (
    <>
      <Form className="dashboardConfigIconWrapper">
        <Form.Field
          label="Select Master Type"
          placeholder="Select Master Type"
          control={Select}
          clearable
          fluid
          search
          selection
          options={masterSelectionOptions}
          onChange={(_e: any, data: any) => {
            setMasterGroupSelection(data.value);
            DashboardConfigurationStore.dataGrid = {
              ...DashboardConfigurationStore.dataGrid,
              masterElement: '[]',
              masterId: '',
              masterName: '',
              automaticPdf: false,
              metaData: [],
            };
          }}
          value={masterGroupSelection}
        />
        <Form.Field
          label={'Select Master'}
          control={Select}
          placeholder={
            dataGrid?.masterName === '' && masterGroupSelection === ''
              ? 'Select Master Type to enable'
              : 'Select Master'
          }
          clearable
          fluid
          search
          selection
          // options={(dataGrid.isMaster ? dataGrid.data : staticTableDetails) || []}
          options={
            masterGroupSelection !== 'static' ? dataGrid.data : staticOptions
          }
          onKeyDown={(e: { keyCode: string; stopPropagation: any }) => {
            if (e.keyCode === 'Backspace' || e.keyCode === 'Delete')
              e.stopPropagation();
          }}
          style={{ marginTop: '5px' }}
          value={dataGrid?.masterName || ''}
          onChange={(_e: any, data: any) => handleMasterChange(_e, data)}
          disabled={dataGrid?.masterName === '' && masterGroupSelection === ''}
        />
        {dataGrid?.masterName === static_items && (
          <>
            <Form.Field
              label={'Select Asset Type'}
              control={Select}
              placeholder={'Select Asset Type'}
              clearable
              fluid
              search
              upward
              selection
              options={assetTypesList}
              onChange={(_e: any, data: any) => handleAssetTypeChange(_e, data)}
              value={dataGrid?.assetType || ''}
            />
            <Form.Field
              label={'Select Element Type'}
              control={Select}
              placeholder={'Select Element Type'}
              clearable
              fluid
              search
              upward
              selection
              options={elementTypesList}
              onChange={(_e: any, data: any) => {
                DashboardConfigurationStore.dataGrid = {
                  ...DashboardConfigurationStore.dataGrid,
                  elementType: data.value,
                };
              }}
              value={dataGrid?.elementType || ''}
            />
          </>
        )}
        {dataGrid?.masterName !== static_workLevel && (
          <Form.Field
            label={'Select Metadata'}
            control={Select}
            placeholder={'Select Metadata'}
            clearable
            fluid
            search
            selection
            multiple
            options={
              dataGrid?.masterId === static_items_id
                ? itemMetaDataOptions
                : metaDataList
            }
            onKeyDown={(e: { keyCode: string; stopPropagation: any }) => {
              if (e.keyCode === 'Backspace' || e.keyCode === 'Delete')
                e.stopPropagation();
            }}
            style={{ marginTop: '5px' }}
            upward
            value={selectedMetaData.map((s) => s.elementName) || []}
            onChange={(_e: any, data: any) => setDataGridMetaData(_e, data)}
          />
        )}
        {/* )} */}
        {/* <Dropdown
        text={dataGrid.isMaster ? 'Master' : 'Static'}
        floating
        labeled
        button
        icon="filter"
        style={{
          position: 'absolute',
          right: '-8px',
          top: '1px',
          gap: '10px',
        }}
        // className='icon'
      >
        <Dropdown.Menu>
          <Dropdown.Item
            onClick={() => {
              DashboardConfigurationStore.dataGrid = {
                ...DashboardConfigurationStore.dataGrid,
                isMaster: true,
              };
            }}
            text="Master"
          />
          <Dropdown.Item
            onClick={() => {
              DashboardConfigurationStore.dataGrid = {
                ...DashboardConfigurationStore.dataGrid,
                isMaster: false,
              };
            }}
            text="Static"
          />
        </Dropdown.Menu>
      </Dropdown> */}
      </Form>
      <div className="dashboardConfigMetadataSelection">
        {masterGroupSelection !== 'static' &&
          dataGrid?.masterElement !== '[]' &&
          dataGrid?.masterElement !== undefined &&
          getParsedMasterElement()?.map((data: IFormDetails) => {
            return (
              <>
                {data.mode !== 2 && data.mode !== undefined && (
                  <div>
                    <Form.Field
                      control={Input}
                      value={data.elementName}
                      readOnly
                    />
                    <span>
                      <span className="disable-checkbox">
                        <Checkbox
                          name="isDisabled"
                          onClick={(_e: SyntheticEvent) => {
                            switchMode(data);
                          }}
                          label="Disable"
                          checked={data.mode !== 1}
                        />
                      </span>
                    </span>
                    <span
                      className="form-set-dependency"
                      onClick={() =>
                        handleDependency(
                          data.elementId,
                          data.elementName,
                          data.elementValue,
                        )
                      }
                    >
                      Set dependency
                    </span>
                    <span>&nbsp;/&nbsp;</span>
                    <span
                      className="data-grid-set-criteria"
                      // className={
                      //   // showCriteria.includes(data.elementId) ||
                      //   data.criteria !== undefined
                      //     ? 'data-grid-set-criteria disabled'
                      //     : 'data-grid-set-criteria'
                      // }
                      onClick={() => handleCriteria(data.elementId)}
                    >
                      Set Criteria
                    </span>
                    {data.dependency !== undefined && (
                      <div className="show-dependency">
                        <label>Based on</label>
                        <Select
                          placeholder="Based on"
                          options={basedOnOptions}
                          value={data.dependency?.basedOn}
                          onChange={(_e: any, basedOnData: any) =>
                            setBasedOn(_e, basedOnData, data.elementId)
                          }
                          disabled={basedOnOptions.length === 0}
                        />
                        {data.elementType === 'Masters' &&
                          data.elementValue !== 'Items' && (
                            <>
                              <label>Check with</label>
                              <Select
                                placeholder="Check with"
                                options={
                                  data.dependency?.checkWithOptions || []
                                }
                                value={data.dependency?.checkWith}
                                onChange={(_e: any, checkWithData: any) =>
                                  setCheckWith(
                                    _e,
                                    checkWithData,
                                    data.elementId,
                                  )
                                }
                              />
                            </>
                          )}

                        <Icon
                          name="close"
                          onClick={() => removeDependency(data.elementId)}
                        />
                      </div>
                    )}

                    {(showCriteria
                      ?.map((crit: { elementId: any }) => crit.elementId)
                      .includes(data.elementId) ||
                      data.criteria !== undefined) && (
                      <>
                        {data?.criteria?.map((crit, index) => {
                          return (
                            <>
                              <div className="show-criteria">
                                <label>Comparison</label>
                                <Select
                                  placeholder="Select comparision"
                                  options={criteriaOptions}
                                  // onChange={changeComparision}
                                  value={crit?.type}
                                  onChange={(_e: any, comparisonData: any) =>
                                    changeComparision(
                                      _e,
                                      comparisonData,
                                      data.elementId,
                                      index,
                                    )
                                  }
                                />
                                <label>Value</label>
                                <Input
                                  placeholder="Enter Value"
                                  value={crit?.value}
                                  onChange={(_e: any, valueData: any) =>
                                    addValue(
                                      _e,
                                      valueData,
                                      data.elementId,
                                      crit.type,
                                      index,
                                    )
                                  }
                                />
                                <Icon
                                  name="close"
                                  onClick={() =>
                                    removeCriteria(data.elementId, index)
                                  }
                                />
                              </div>
                            </>
                          );
                        })}
                      </>
                    )}
                  </div>
                )}
              </>
            );
          })}
      </div>
      {masterGroupSelection !== 'static' && (
        <div className="pdf-download">
          <Checkbox
            name="isPDF"
            label="Automatic PDF Download after Data Grid Save"
            onClick={(_e: SyntheticEvent, data: any) => {
              DashboardConfigurationStore.dataGrid = {
                ...DashboardConfigurationStore.dataGrid,
                automaticPdf: data.checked,
              };
            }}
            checked={DashboardConfigurationStore.dataGrid.automaticPdf}
          />
        </div>
      )}

      {masterGroupSelection !== 'static' && selectedMetaData.length > 0 && (
        <>
          <label>Edit / Delete Disable If</label>
          <br />
          <br />
          <Dropdown
            style={selectStyle}
            upward
            clearable
            search
            options={EditAndDeleteOptions()}
            selection
            placeholder="metadata"
            onChange={(_event: any, data: any) => {
              SetEditAndDeleteValue({
                ...editAndDeleteValue,
                metadata: data.value,
              });
              if (data.value === '') {
                clearEditAndDelete();
              }
            }}
            value={editAndDeleteValue.metadata}
          />

          {editAndDeleteValue.metadata && (
            <>
              <Dropdown
                upward
                clearable
                style={selectStyle}
                search
                options={criteriaOptions}
                selection
                placeholder="comparison"
                onChange={(_event: any, data: any) => {
                  handleEditAndDeleteComparison(data.value, '');
                  if (data.value === '') {
                    SetEditAndDeleteValue({
                      ...editAndDeleteValue,
                      comparison: '',
                      value: '',
                    });
                  }
                }}
                value={editAndDeleteValue.comparison}
              />
              <input
                type="text"
                placeholder="Value"
                style={selectStyle}
                value={editAndDeleteValue.value}
                onChange={(e) => {
                  handleEditAndDeleteComparison('', e.target.value);
                  if (e.target.value === '') {
                    SetEditAndDeleteValue({
                      ...editAndDeleteValue,
                      value: '',
                    });
                  }
                }}
              />
            </>
          )}
        </>
      )}
    </>
  );
}

export default DataGrid;
